
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 125 125"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M65.8 50.1l-13-32.7c-1-2.5-4.6-2.5-5.6 0L34.7 50.1 17.3 33.8c-2.2-2-5.7 0-4.9 2.9l7.1 28.8c.5 2 2.3 3.5 4.5 3.5h52.5c2.1 0 4-1.5 4.5-3.5l7.1-28.8c.7-2.9-2.8-4.9-4.9-2.9L65.8 50.1zM75.2 81.5H25.8c-2.6 0-4.7-2.1-4.7-4.7s2.1-4.7 4.7-4.7h49.3c2.6 0 4.7 2.1 4.7 4.7s-2.1 4.7-4.6 4.7z"}})])
          )
        }
      }
    